import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import "./Auth.css";

export default function Register({ navigateTo }) {
  const { register } = useAuth();

  const [formData, setFormData] = useState({
    username: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [serverError, setServerError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      const numericValue = value.replace(/[^0-9]/g, "");
      const limitedValue = numericValue.slice(0, 11);

      setFormData((prev) => ({ ...prev, [name]: limitedValue }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }

    if (serverError) {
      setServerError("");
    }

    if (success) {
      setSuccess("");
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.username || formData.username.trim().length < 3) {
      newErrors.username = "نام کاربری باید حداقل 3 کاراکتر باشد";
    }

    if (!formData.phone) {
      newErrors.phone = "لطفاً شماره موبایل را وارد کنید";
    } else if (!/^[0-9]{11}$/.test(formData.phone)) {
      newErrors.phone = "شماره موبایل باید 11 رقم باشد";
    }

    if (!formData.email) {
      newErrors.email = "لطفاً ایمیل را وارد کنید";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "ایمیل معتبر نیست";
    }

    if (!formData.password) {
      newErrors.password = "لطفاً رمز عبور را وارد کنید";
    } else if (formData.password.length < 8) {
      newErrors.password = "رمز عبور باید حداقل 8 کاراکتر باشد";
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "لطفاً تکرار رمز عبور را وارد کنید";
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "رمز عبور با تکرار آن مطابقت ندارد";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setServerError("");
    setSuccess("");

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      const result = await register(
        formData.username,
        formData.phone,
        formData.email,
        formData.password
      );

      if (result.success) {
        setSuccess("ثبت‌نام با موفقیت انجام شد! در حال انتقال به صفحه ورود...");

        setFormData({
          username: "",
          phone: "",
          email: "",
          password: "",
          confirmPassword: "",
        });

        setTimeout(() => {
          navigateTo("login");
        }, 1800);
      } else {
        setServerError(result.message || "ثبت‌نام ناموفق بود");
      }
    } catch (error) {
      console.error("Register error:", error);
      setServerError("خطا در ثبت‌نام. لطفاً اتصال به دیتابیس را بررسی کنید.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h2>ثبت‌نام در نقش خیال</h2>
          <p>لطفاً اطلاعات خود را وارد کنید</p>
        </div>

        <div className="auth-body">
          <button
            type="button"
            className="back-to-shop"
            onClick={() => navigateTo("shop")}
            disabled={loading}
          >
            ← بازگشت به فروشگاه
          </button>

          {serverError && (
            <div
              className="error-message"
              style={{
                textAlign: "center",
                marginBottom: "20px",
                color: "#e74c3c",
              }}
            >
              {serverError}
            </div>
          )}

          {success && <div className="success-message">{success}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label style={{ textAlign: "right" }}>نام کاربری *</label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                className={errors.username ? "error" : ""}
                disabled={loading}
                autoComplete="username"
              />
              {errors.username && (
                <span className="error-message">{errors.username}</span>
              )}
            </div>

            <div className="form-group">
              <label style={{ textAlign: "right" }}>شماره موبایل *</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="09123456789"
                dir="ltr"
                className={errors.phone ? "error" : ""}
                disabled={loading}
                autoComplete="tel"
              />
              {errors.phone && (
                <span className="error-message">{errors.phone}</span>
              )}
            </div>

            <div className="form-group">
              <label style={{ textAlign: "right" }}>ایمیل *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="example@email.com"
                dir="ltr"
                className={errors.email ? "error" : ""}
                disabled={loading}
                autoComplete="email"
              />
              {errors.email && (
                <span className="error-message">{errors.email}</span>
              )}
            </div>

            <div className="form-group">
              <label style={{ textAlign: "right" }}>
                رمز عبور (حداقل 8 کاراکتر) *
              </label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className={errors.password ? "error" : ""}
                disabled={loading}
                autoComplete="new-password"
              />
              {errors.password && (
                <span className="error-message">{errors.password}</span>
              )}
            </div>

            <div className="form-group">
              <label style={{ textAlign: "right" }}>تکرار رمز عبور *</label>
              <input
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                className={errors.confirmPassword ? "error" : ""}
                disabled={loading}
                autoComplete="new-password"
              />
              {errors.confirmPassword && (
                <span className="error-message">{errors.confirmPassword}</span>
              )}
            </div>

            <button type="submit" className="auth-button" disabled={loading}>
              {loading ? "در حال ثبت‌نام..." : "ثبت‌نام"}
            </button>
          </form>
        </div>

        <div className="auth-footer">
          <p>قبلاً ثبت‌نام کرده‌اید؟</p>
          <button
            type="button"
            onClick={() => navigateTo("login")}
            disabled={loading}
          >
            ورود به حساب کاربری
          </button>
        </div>
      </div>
    </div>
  );
}